(function () {
  'use strict';

  angular
    .module('alvBidding')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('alvBidding', {
        url: '/alv-bidding',
        views : {
          'alvBiddingView' : {
            templateUrl: 'alv-bidding/views/alv-bidding.tpl.html',
            controller: 'AlvBiddingCtrl',
            controllerAs: 'alvBidding'
          }
        }
      });
  }
}());
